import { render, staticRenderFns } from "./WithdrawList.vue?vue&type=template&id=d679204c&scoped=true"
import script from "./WithdrawList.vue?vue&type=script&lang=js"
export * from "./WithdrawList.vue?vue&type=script&lang=js"
import style0 from "./WithdrawList.vue?vue&type=style&index=0&id=d679204c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d679204c",
  null
  
)

export default component.exports